module.exports = __webpack_public_path__ + "img/3.2792b50c.jpg";